// Local dependencies
import { ResetError } from '../../../../common/types/reset-error';
import { Logo } from '../../../utils/types';

export interface CreateCategoryInput {
  code: string;
  name_en: string;
  name_ky: string;
  name_ru: string;
  name_tr: string;
  popularityScore: number;
  logo?: Logo;
  tags?: string[];
  rboCode?: string;
}

export interface CreateCategoryState {
  loading: boolean;
  error: Error | null;
  success: boolean;
}

export enum CreateCategoryActionType {
  CREATE_CATEGORY = 'CREATE_CATEGORY',
  CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS',
  CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_ERROR',

  CLOSE_SUCCESS_POPUP = 'CLOSE_SUCCESS_POPUP',
  RESET_ERROR = 'RESET_ERROR',
}

export interface CreateCategory {
  type: CreateCategoryActionType.CREATE_CATEGORY;
  input: CreateCategoryInput;
}

export interface CreateCategorySuccess {
  type: CreateCategoryActionType.CREATE_CATEGORY_SUCCESS;
}

export interface CreateCategoryError {
  type: CreateCategoryActionType.CREATE_CATEGORY_ERROR;
  error: Error;
}

export interface CloseSuccessPopup {
  type: CreateCategoryActionType.CLOSE_SUCCESS_POPUP;
}

export type CreateCategoryAction =
  | CreateCategory
  | CreateCategorySuccess
  | CreateCategoryError
  | ResetError<CreateCategoryActionType.RESET_ERROR>
  | CloseSuccessPopup;
